module.exports = __webpack_public_path__ + "img/yoga_girl.6bcf1f4b.png";